export function keyOf<T>(key: keyof T): keyof T {
  return key;
}
